/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-, tab- or space-separated X,Y rows, with an optional all-text header row to name the axes.`)
};

const es_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas X,Y separadas por comas, tabulaciones o espacios, con una fila de cabecera opcional totalmente de texto para nombrar los ejes.`)
};

const de_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Kommas, Tabulatoren oder Leerzeichen getrennte X,Y-Zeilen, mit einer optionalen reinen Text-Kopfzeile zur Benennung der Achsen.`)
};

const nl_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komma-, tab- of spatiegescheiden X,Y-rijen, met een optionele headerrij die volledig uit tekst bestaat om de assen te benoemen.`)
};

const fr_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des lignes X,Y séparées par des virgules, des tabulations ou des espaces, avec une ligne d'en-tête entièrement textuelle optionnelle pour nommer les axes.`)
};

const it_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe X,Y separate da virgole, tabulazioni o spazi, con una riga di intestazione opzionale interamente testuale per nominare gli assi.`)
};

const pt_br2_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas de pares X,Y separadas por vírgula, tabulação ou espaço, com uma linha de cabeçalho totalmente textual opcional para nomear os eixos.`)
};

const pt_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas X,Y separadas por vírgulas, tabulações ou espaços, com uma linha de cabeçalho opcional totalmente textual para nomear os eixos.`)
};

const ja_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマ、タブ、またはスペース区切りのX, Y行で、軸に名前を付けるための任意の全文字ヘッダー行にも対応しています。`)
};

const zh_scatter_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以逗号、制表符或空格分隔的 X,Y 行，可选一行全文本的表头用于命名坐标轴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_faq_a3", locale)
	if (locale === "en") return en_scatter_faq_a3(inputs)
	if (locale === "es") return es_scatter_faq_a3(inputs)
	if (locale === "de") return de_scatter_faq_a3(inputs)
	if (locale === "nl") return nl_scatter_faq_a3(inputs)
	if (locale === "fr") return fr_scatter_faq_a3(inputs)
	if (locale === "it") return it_scatter_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_faq_a3(inputs)
	if (locale === "pt") return pt_scatter_faq_a3(inputs)
	if (locale === "ja") return ja_scatter_faq_a3(inputs)
	return zh_scatter_faq_a3(inputs)
};